import {
  DS_INLINE_TOKEN_VARIANT,
  DSInlineTokenVariant,
} from "@/src/design_system/data_display/inline_token/types/props";

export const DS_INLINE_TOKEN_VARIANT_TO_DESCRIPTION_KEY: Record<
  DSInlineTokenVariant,
  keyof typeof window.I18n.designSystem.inlineToken
> = {
  [DS_INLINE_TOKEN_VARIANT.Default]: "variantDefault",
  [DS_INLINE_TOKEN_VARIANT.Raised]: "variantRaised",
  [DS_INLINE_TOKEN_VARIANT.Primary]: "variantPrimary",
  [DS_INLINE_TOKEN_VARIANT.Neutral]: "variantNeutral",
  [DS_INLINE_TOKEN_VARIANT.Danger]: "variantDanger",
  [DS_INLINE_TOKEN_VARIANT.Ghost]: "variantGhost",
} as const;
